// extracted by mini-css-extract-plugin
module.exports = {"description":"_1R_01","actionable":"rwCDH","colorSamplerGroup":"_2-zrV"};